export default "__VITE_ASSET__2cde39fc__$_?component__"